var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-center"},[_c('v-overlay',{staticClass:"flex-column",attrs:{"value":_vm.showLoadingDialog}},[_c('p',[_vm._v(_vm._s(_vm.loadingDialogMessage))]),_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }